import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import * as routeLink from "../../constants/routeLink";
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from "../../actions/index";
import { formatNumber, getBgInInvest } from '../../services/services';
const Index = (props) => {
  const dispatch = useDispatch()
  const { appReducer } = useSelector(state => state);

  return (
    <div className='d-flex flex-column card-custom align-items-center w-100'>
      <div className='d-flex p-2'>
        <div className='card-img w-50 me-2'>
          <img src={`${routeLink.domain}/assets/up/${props?.item?._id}.png`} className=' object-fit-cover assdasdsaddsds' />
        </div>
        <div className='card-info  w-50 text-white'>
          <h4 className='fs-title-card fw-bold'>{props?.item.title}</h4>
          <p className='mb-0 text-cart'>{props?.item.description}</p>
          <div className='d-flex w-100' style={{ alignItems: 'center' }}>
            <div className='card-icon me-2  d-flex align-items-center justify-content-center '>
              <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
            </div>
            <span className=''> <span className=''> +{formatNumber(props?.item.price * 0.05 / 30)}</span></span>
          </div>
        </div>
      </div>
      <div className='d-flex  w-100 p-2 divider-top position-relative'>

        <div className='d-flex  align-items-center justify-content-center btn w-40 p-0'>
          <div className='card-icon d-flex align-items-center justify-content-center me-1' style={{ width: "20px", height: "20px" }}>
            <img className='w-100 h-100' src={`https://cdn-icons-png.flaticon.com/256/4614/4614145.png`} />
          </div>

          <span className='text-white font-size-global' style={{ fontSize: 18 }}>{props?.item?.level}</span>
        </div>
        <button className={`d-flex  align-items-center justify-content-center btn w-60 btn-custom-sm mt-1 scale_btn btn-card p-0 ${getBgInInvest(props?.item.price)}`} onClick={() => props?.actions(props?.item)}>
          <span className='text-white fw-bold me-2' style={{ fontSize: 14 }}> {formatNumber(props?.item.price)}</span>
          <div className='card-icon d-flex align-items-center justify-content-center'> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /> </div>

        </button>
      </div>
    </div>
  )
}

export default Index;
